import React from 'react';

function Screenshot(props) {
  const { onDelete, src, onClick } = props;

  return (
    <div className="image-wrap" onClick={onClick}>
      <button type="button" className="remove-image" onClick={onDelete}>
        <img src="/resources/img/remove-circle.svg" alt="Remove" />
      </button>
      <img className="screenshots-img" src={src} alt="" />
    </div>
  );
}

export default Screenshot;



// WEBPACK FOOTER //
// ./src/components/Screenshot.jsx